import React from 'react';
import { Box, Typography } from '@mui/material';

interface EditProps {
  solutionName: string;
}

const Edit: React.FC<EditProps> = ({ solutionName }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
      <Typography
        variant='bodyMd'
        color='text.secondary'
      >
        {solutionName} settings coming soon.
      </Typography>
    </Box>
  );
};

export default Edit;
